import React from 'react';

import { useTranslation } from 'react-i18next';

import { FORECAST_COLORS, PROJECTED_PATTERN_ID } from './constants';
import { LegendRow } from './styles';

/**
 * One legend for both panes, which form a single reading. Every entry is named, so identity
 * never rests on colour alone.
 */
const ForecastLegend: React.FC = () => {
  const { t } = useTranslation('translation');

  return (
    <LegendRow>
      <span>
        <i style={{ backgroundColor: FORECAST_COLORS.storeStock }} aria-hidden="true" />
        {t('productOptimalStock.sales_forecast.store_stock')}
      </span>
      <span>
        <i style={{ backgroundColor: FORECAST_COLORS.warehouseStock }} aria-hidden="true" />
        {t('productOptimalStock.sales_forecast.warehouse_stock')}
      </span>
      <span>
        <i style={{ backgroundColor: FORECAST_COLORS.outstandingSupply }} aria-hidden="true" />
        {t('productOptimalStock.sales_forecast.outstanding_supply')}
      </span>
      <span>
        <i className="hatched" aria-hidden="true">
          <svg width="12" height="12">
            <rect width="12" height="12" fill={`url(#${PROJECTED_PATTERN_ID}-legend)`} />
          </svg>
        </i>
        {t('productOptimalStock.sales_forecast.projected_stock')}
      </span>
      <span>
        <i className="line" aria-hidden="true" />
        {t('productOptimalStock.sales_forecast.sales')}
      </span>
      <span>
        <i className="line dashed" aria-hidden="true" />
        {t('productOptimalStock.sales_forecast.forecast')}
      </span>
    </LegendRow>
  );
};

export default ForecastLegend;
